import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/ui/PageHeader.js";
import { DataTable, type Column } from "@/components/ui/DataTable.js";
import { StatusBadge } from "@/components/ui/StatusBadge.js";
import { api } from "@/lib/api.js";
import { absoluteDateTime } from "@/lib/format.js";

interface Entry {
  id: number;
  at: string;
  actorEmail: string | null;
  actorIp: string | null;
  action: string;
  resourceType: string;
  resourceId: string | null;
  targetIdcompany: number | null;
  result: string;
  reason: string | null;
}

export function AuditPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["audit"],
    queryFn: () => api.get<{ items: Entry[] }>("/audit?pageSize=100"),
  });

  const cols: Column<Entry>[] = [
    { header: "Fecha", render: (r) => absoluteDateTime(r.at), width: "170px" },
    { header: "Actor", render: (r) => r.actorEmail ?? "sistema" },
    { header: "IP", render: (r) => <span className="mono text-xs">{r.actorIp ?? "—"}</span> },
    {
      header: "Acción",
      render: (r) => (
        <div>
          <span className="mono text-xs">{r.action}</span>
          <div className="text-xs text-slate-500">
            {r.resourceType}{r.resourceId ? `:${r.resourceId}` : ""}
          </div>
        </div>
      ),
    },
    { header: "Company", render: (r) => r.targetIdcompany ?? "—", width: "100px" },
    { header: "Resultado", render: (r) => <StatusBadge value={r.result} /> },
    { header: "Motivo", render: (r) => <span className="text-xs">{r.reason ?? "—"}</span> },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Audit log"
        description="Toda acción ejecutada desde este backoffice queda registrada aquí."
      />
      <DataTable
        columns={cols}
        rows={data?.items}
        loading={isLoading}
        getKey={(r) => r.id}
        empty="No hay eventos registrados."
      />
    </div>
  );
}
